import React from 'react';
import { Toolbar, ToolbarTitle } from 'material-ui/Toolbar';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import { HashLink } from 'react-router-hash-link';
import COLORS from '../../../theme/colors';

import './general.scss';

export default function General() {
  return (
    <div className="general">
      <Toolbar style={{ backgroundColor: COLORS.purple }}>
        <ToolbarTitle
          text="GENERAL"
          style={{ color: COLORS.white }}
        />
      </Toolbar>

      {/* eslint-disable max-len */}
      <div className="content">
        <Card className="card">
          <CardHeader
            title="How does TeamHub work?"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            {"TeamHub displays on your office TVs what your team considers important and trending in your Slack public channels or in your teams' Webex spaces."}
          </CardText>
        </Card>

        <Card className="card">
          <CardHeader
            title="How to connect TeamHub with our TVs?"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            To display your TeamHub content on the big screen you can either use Chromecast, or pair your office TV manually.
          </CardText>
        </Card>

        <Card className="card">
          <CardHeader
            title="Who can add messages to the TeamHub feed?"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            That’s the fun - everyone from your Slack or Webex team.
          </CardText>
        </Card>

        <Card className="card">
          <CardHeader
            title="Do the messages automatically rotate?"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            Yes, they do! Each message is displayed for 60 seconds on the screen unless it’s not a YouTube video.
          </CardText>
        </Card>

        <Card className="card">
          <CardHeader
            title="How long does it take for new content to appear on TV?"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            It may take up to 5 minutes for new content to appear on the TV screen.
          </CardText>
        </Card>

        <Card className="card">
          <CardHeader
            title="Why I don’t see my yesterday's news on TV?"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            News are meant to be new… We broadcast posts from the last 24 hours only.
          </CardText>
        </Card>

        <Card className="card">
          <CardHeader
            title="Can I disable a public channel from my TeamHub feed?"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            Yes! You can easily turn on/off which public channels to feature in your TeamHub feed from the TeamHub Dashboard page.
          </CardText>
        </Card>

        <Card className="card">
          <CardHeader
            title="How many people need to react to a Slack message for it to appear?"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            Any post with reactions from at least 4 unique users will be added in your TeamHub feed.
          </CardText>
        </Card>

        <Card className="card">
          <CardHeader
            title="How to add an important post to the TeamHub feed?"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            <ul>
              <li>
                Simply add a 📰(:newspaper:) reaction to it in Slack. Keep in mind that it has to be posted on a public channel that is enabled in TeamHub.
              </li>
              <li>
                If you are a Webex user just add #news in your message and it will appear on the TV. Likewise the message has to be sent in a public space, not in a private conversation.
              </li>
            </ul>
          </CardText>
        </Card>

        <Card className="card">
          <CardHeader
            title="How to remove inappropriate message from the TeamHub feed?"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            Just add a  🌵(:cactus:) reaction to it in Slack or edit your Webex message and remove the #news.
          </CardText>
        </Card>

        <Card className="card">
          <CardHeader
            title="Can I use TeamHub if I don’t have a Slack account?"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            Yes, you can! You can use TeamHub to display posts only from your Webex account.
          </CardText>
        </Card>

        <Card className="card">
          <CardHeader
            title="Can I play a video in the TeamHub feed?"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            Yes, you can! Whenever a YouTube video is posted on a public channel or space, has  📰(:newspaper:) reaction, #news or is trending, you can watch it on the big screen.
          </CardText>
        </Card>

        <Card className="card">
          <CardHeader
            title="Why I don’t see a Slack post that is marked as important or is trending in the TeamHub feed?"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            Two possible reasons for that:
            <ol type="a">
              <li>
                Check in your TeamHub Dashboard page whether the public channel of the post is disabled. If so, enable the channel and the message will appear in the feed.
              </li>
              <li>
                Check in Slack if a user has reacted with  🌵(:cactus:)  to the message. TeamHub removes all messages with 🌵(:cactus:)  reaction from the feed.
              </li>
            </ol>
          </CardText>
        </Card>

        <Card className="card">
          <CardHeader
            title="Why my TeamHub feed is not updated after I have modified the source settings?"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            The TeamHub feed will be updated in 5 minutes after you make any changes in the source settings (e.g. turn channels on or off).
          </CardText>
        </Card>

        <Card className="card">
          <CardHeader
            title="Can I change the Slack workspace I am using for broadcast?"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            Yes! It’s easy - just press the REMOVE button from the Slack section of your TeamHub Dashboard. Then follow the instructions from the dialogue to remove your current Slack integration.
            <br />
            <b>Don’t forget to refresh your Dashboard page after you remove your integration!</b>
            <br />
            To add a different Slack workspace look at <HashLink to="/faq#set-up">Set up your Content Sources.</HashLink>

          </CardText>
        </Card>
      </div>
      { /* eslint-enable max-len */}
    </div >
  );
}



// WEBPACK FOOTER //
// ./src/components/faq/general/general.jsx